import axios from 'axios'
import { add_job, add_jobs } from '../jobSlice'

async function post_job(token,jobs,dispatch,setOpen,setMessage,data,setLoading,navigate){
    
    setLoading(true)

    // console.log(data)

    const addJob = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}post-job/`,data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${token}`
            }
    }).catch(err=>{
        console.log(err)
        setMessage("error while uploading")
        setOpen(true)
        setLoading(false)
    })

    if (addJob?.status == 200 && addJob?.data?.success == true) {

        setMessage("Job created")
        setOpen(true)
        dispatch(add_job(addJob?.data?.job))
        dispatch(add_jobs([...jobs,addJob?.data?.job]))
        setLoading(false)
        navigate("/jobInfo")

    }else{
        console.log(addJob?.data)
        setMessage(addJob?.data?.message)
        setOpen(true)
        setLoading(false)
    }

}

export default post_job